import {
  BarChart3Icon,
  CalendarIcon,
  ClockIcon,
  FileTextIcon,
  HardHatIcon,
  LayoutDashboardIcon,
  ListChecksIcon,
  PackageIcon,
  ReceiptIcon,
  SettingsIcon,
  ShieldIcon,
  SparklesIcon,
  TagIcon,
  TargetIcon,
  UsersIcon,
  WrenchIcon,
} from 'lucide-react'
import { View } from '../types/view'

export interface NavItem {
  id: View
  label: string
  icon: typeof LayoutDashboardIcon
  /** Only visible to users with the Admin role. */
  adminOnly?: boolean
  /** Small accent pill shown after the label, e.g. "NY". */
  badge?: string
}

export interface NavGroup {
  /** Uppercase section label. Omit for the top, unlabelled group. */
  label?: string
  items: NavItem[]
}

/**
 * Sidebar grouped by where you are in the working day: what is coming in,
 * what is being sold, what is being built, and what it earned.
 */
export const navGroups: NavGroup[] = [
  {
    label: 'Overblik',
    items: [
      { id: 'pro-dashboard', label: 'Dashboard', icon: LayoutDashboardIcon },
      { id: 'pro-leads', label: 'Leads', icon: TargetIcon },
      { id: 'pro-calendar', label: 'Kalender', icon: CalendarIcon },
    ],
  },
  {
    label: 'Salg',
    items: [
      { id: 'pro-customers', label: 'Kunder', icon: UsersIcon },
      { id: 'pro-quotes', label: 'Tilbud', icon: FileTextIcon },
      { id: 'mester-ai', label: 'Mester-AI', icon: SparklesIcon, badge: 'NY' },
    ],
  },
  {
    label: 'Udførelse',
    items: [
      { id: 'pro-jobs', label: 'Opgaver', icon: WrenchIcon },
      { id: 'pro-time', label: 'Timer', icon: ClockIcon },
      { id: 'pro-materials', label: 'Materialer', icon: PackageIcon },
      { id: 'quality', label: 'Kvalitetssikring', icon: ListChecksIcon },
    ],
  },
  {
    label: 'Økonomi',
    items: [
      { id: 'pro-invoices', label: 'Fakturaer', icon: ReceiptIcon },
      { id: 'pro-products', label: 'Produkter', icon: TagIcon },
      { id: 'pro-employees', label: 'Medarbejdere', icon: HardHatIcon },
      { id: 'pro-statistics', label: 'Statistik', icon: BarChart3Icon },
    ],
  },
  {
    label: 'System',
    items: [
      { id: 'regelgrundlag', label: 'Regelgrundlag', icon: FileTextIcon },
      { id: 'users', label: 'Brugere', icon: ShieldIcon, adminOnly: true },
      { id: 'pro-settings', label: 'Indstillinger', icon: SettingsIcon },
    ],
  },
]
